export { RestrictionComponentModal } from './RestrictionComponentModal';
